import React from "react";
import { ISaleRow } from "../../../models/response/ITotallingManagementResponse";
import { FormattedMessage } from "react-intl";
import { showAmountWithFormatting } from "../../../helpers/common-component-helper";
import { ISorting, ISortingCustom } from "../../../models/ISorting";
import { observer } from "mobx-react";
import { serviceTypeEnum } from "../../../constants/enums/service-type-enum";
import { formatMessage } from "../../../translations/format-message";

interface IProps {
  data: ISaleRow[];
  handleSortingChange: (accessor: string) => void
  sorting: ISortingCustom;
}

const CustomerToTreatmentProductDailySales: React.FC<IProps> = ({ data, handleSortingChange, sorting }) => {
  return (
    <div className="table-responsive all-day-table mb-4">
      <table className="table table-bordered align-middle">
        <thead className="table-dark">
          <tr>
           <th
              onClick={()=>{handleSortingChange("status")}}
              className="cursor-pointer select-none px-3 py-2"
            >
              <div className="">
                <span className="me-2">
                  <FormattedMessage id="status" />
                </span>
                {
                  sorting.column === "status" ?
                  <>
                    {sorting.orderBy === "asc" ? (
                      <i className="bi bi-arrow-up"></i>
                    ) : sorting.orderBy === "desc" ? (
                      <i className="bi bi-arrow-down"></i>
                    ) : (
                      <i className="bi bi-arrow-down-up text-muted"></i>
                    )}
                  </> :
                  <i className="bi bi-arrow-down-up text-muted"></i>
                }
              </div>
            </th>
            <th>
              <FormattedMessage id="customer_name" />
            </th>
            <th>
              <FormattedMessage id="treatment_options_merchandise" />
            </th>
            <th>
              <FormattedMessage id="main_staff" />
            </th>
            <th>
              <FormattedMessage id="reservation_time" />
            </th>
            <th>
              <FormattedMessage id="total_payment_amount" />
            </th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((row, idx) => (
            <tr key={idx}>
              <td
                className={
                  row.Status === "Invoiced/Accounted"
                    ? "text-primary fw-bold"
                    : "text-secondary"
                }
              >
                {formatMessage(row.Status)}
              </td>
              <td>{row.CustomerName}</td>
              <td>
                {row.Details.map((item, i) => (
                  <div key={i}>{item.Name} 
                  {
                    item.ItemType === serviceTypeEnum.Option &&
                    <span className="badge bg-primary rounded ms-2">
                      <FormattedMessage id="option" />
                    </span>
                  } 
                  </div>
                ))}
              </td>
              <td>{row.StaffName}</td>
              <td>{row.ReservationTime}</td>
              <td >{showAmountWithFormatting(row.Amount)}</td>
            </tr>
            ))
           ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  <FormattedMessage id="no_data_found" />
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
    </div>
  );
};

export default observer(CustomerToTreatmentProductDailySales);
